<template>
	<div :class="`bg-${color}-100 border-t border-b border-${color}-500 text-${color}-700 px-4 py-3`" role="alert">
		<p v-if="title" class="font-bold">{{ title }}</p>
		<p class="text-sm"><slot></slot></p>
	</div>
</template>

<script>
export default {
    name: "Alert",
    props: {
    	title: {
    		default: null,
        },
        color: {
    		default: 'green'
        }
    }
}
</script>

<style scoped>

</style>